<template>
    <div class="flex justify-center">
        <div class="mt-10 w-full px-3 md:w-2/3 lg:w-2/4 text-secondary text-center">
            <img class="w-full md:w-1/3 lg:w-2/4 mx-auto" src="@/assets/not-found.svg">
            <h1 class="text-3xl">
                {{ translate('The page you are looking for could not be found!', 'ucfirst') }}
            </h1>
            <p class="mt-5">
                {{ translate('We apologize for the inconvenience, but the page you were looking for does not exist in our system. Below are some useful links:', 'ucfirst') }}
            </p>
            <div class="mt-10 flex justify-center">
                <router-link v-for="item, index of links" :key="index" :to="item.to" class="mx-3 underline font-bold">
                    {{ translate(item.name, 'ucfirst') }}
                </router-link>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { showToast } from '@/composables/toast';
    import { translate } from '@/composables/translate';
    import { useSessionMessageStore } from '@/stores/sessionMessage';
    import { useToast } from 'primevue/usetoast';
    import { onMounted, ref } from 'vue';

    const toast = useToast();
    const messageStore = useSessionMessageStore();

    const links = ref([
        {name: 'home', to: '/'},
        {name: 'enter', to: '/login'},
        {name: 'register', to: '/register'},
    ])

    onMounted(() => {
        if (messageStore.hasMessage) {
            showToast(toast, messageStore.getMessageType, messageStore.getMessageType);
            messageStore.cleanMessage();
        }
    })
</script>